import { cn } from '../../lib/utils';
import { useTheme } from '../../contexts/ThemeContext';

const SRC_WHITE = '/brand/logos/zitius-logo-white-text-v2.png';
const SRC_BLACK = '/brand/logos/zitius-logo-black-text-v2.png';

/** Full horizontal lockup; height-led sizing. */
const sizes = {
  sm: 'h-9 w-auto max-w-[min(100%,11rem)]',
  md: 'h-11 w-auto max-w-[min(100%,13rem)]',
  lg: 'h-16 sm:h-[4.25rem] w-auto max-w-[min(100%,20rem)]',
};

/**
 * @param {'default' | 'light' | 'dark'} variant
 * - `default` — menu: black lockup in light theme, white in dark theme.
 * - `light` — login / dark surfaces: always white lockup.
 * - `dark` — always black lockup (light backgrounds only).
 * `showWordmark` is unused (wordmark is in the asset); kept for API compatibility.
 */
const ZitiusLogo = ({
  size = 'md',
  variant = 'default',
  className,
  showWordmark: _showWordmark = true,
}) => {
  const { mode } = useTheme();

  const src =
    variant === 'light'
      ? SRC_WHITE
      : variant === 'dark'
        ? SRC_BLACK
        : mode === 'dark'
          ? SRC_WHITE
          : SRC_BLACK;

  const imgClass = sizes[size] || sizes.md;

  return (
    <img
      src={src}
      alt='Zitius'
      className={cn('object-contain object-left shrink-0', imgClass, className)}
    />
  );
};

export default ZitiusLogo;
